import { Participant } from 'twilio-video'

import { useCallManager } from '../../../contexts/call_manager_context'

export const useIsLocalParticipant = (participant?: Participant | null) => {
  const {
    activeCall: { room },
  } = useCallManager()

  return room && participant && participant === room.localParticipant
}
